import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';

import { FieldArray, reduxForm, SubmissionError } from 'redux-form';

import Section, { SectionHeader, SectionTitle, SectionBody } from 'components/common/Section';
import Button from 'components/common/Button';
import TextField, { TextFieldAdornmentText } from 'components/fields/TextField';
import FormError from 'components/common/FormError';

import {
  createBusinessTwilioCredentials, updateBusinessTwilioCredentials,
} from 'redux/modules/business';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

import BusinessTwilioCredentialsFieldArray from './BusinessTwilioCredentialsFieldArray';

const styles = theme => ({
  grid: {
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 4,
    },
  },
  gridGutter: {
    marginTop: 15,
  },
  button: {
    marginLeft: 20,
  },
  form: {
    width: 468,
    margin: '10px auto',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  buttons: {
    display: 'flex',
    flexWrap: 'nowrap',
  },
});

function onSubmit(values, dispatch, props) {
  if (props.initialValues['Twilio Credentials'].length > 0) {
    return new Promise((resolve, reject) => {
      dispatch(updateBusinessTwilioCredentials({
        values,
        resolve,
        reject,
      }));
    }).then(res => res,
      (err) => {
        if (err.error) {
          throw new SubmissionError({ _error: err.error });
        }
        throw new SubmissionError(err);
      });
  }
  return new Promise((resolve, reject) => {
    dispatch(createBusinessTwilioCredentials({
      values,
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

const BusinessTwilioCredentialsForm = ({
  submit,
  reset,
  handleSubmit,
  submitting,
  error,
  classes,
}) => (
  <Section>
    <SectionHeader
      fixed
      top={110}
    >
      <SectionTitle>
        Twilio Credentials
      </SectionTitle>
      <div className={classes.buttons}>
        <Button
          className={classes.button}
          variant="raised"
          onClick={reset}
        >
          Reset
        </Button>
        <Button
          className={classes.button}
          variant="raised"
          color="primary"
          disabled={submitting}
          onClick={submit}
        >
          Save
        </Button>
      </div>
    </SectionHeader>
    <SectionBody>
      <form
        className={classes.form}
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        {error &&
          <Grid
            className={classes.grid}
            container
            spacing={24}
          >
            <Grid
              item
              xs={12}
            >
              <FormError>
                {error}
              </FormError>
            </Grid>
          </Grid>
        }
        <FieldArray
          name="Twilio Credentials"
          component={BusinessTwilioCredentialsFieldArray}
        />
      </form>
    </SectionBody>
  </Section>
);

BusinessTwilioCredentialsForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  error: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
    gridGutter: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
  }).isRequired,
};

BusinessTwilioCredentialsForm.defaultProps = {
  error: null,
};

export default reduxForm({
  onSubmit,
  enableReinitialize: true,
})(withStyles(styles)(BusinessTwilioCredentialsForm));



// WEBPACK FOOTER //
// ./src/components/settings/BusinessTwilioCredentialsForm/BusinessTwilioCredentialsForm.js